import {
    BuyFromSylndr,
    BuyFromSylndrMiniAr,
    ReInspect,
    ReInspectMiniAr,
} from 'public/Images';
import { StaticImageData } from 'next/image';

export interface SylndrHelpPoint {
    key: string;
    index: number;
    title: { en: string; ar: string };
    subTitle: { en: string; ar: string };
    desc: { en: string; ar: string };
    stepsTitle: { en: string; ar: string };
    steps: { title: { en: string; ar: string } }[];
    cost: { en: string; ar: string };
    info: { en: string; ar: string };
    icon: string | StaticImageData;
    miniIcon: string | StaticImageData;
    miniIconAr?: string | StaticImageData;
    videoURL: { DESKTOP: string; MOBILE: string };
}
export const SylndrHelpPoints: SylndrHelpPoint[] = [
    {
        key: 'ReInspect',
        index: 0,
        title: {
            ar: 'إعادة الفحص مع سيلندر',
            en: 'Reinspection with Sylndr',
        },
        subTitle: {
            ar: 'مهندسين سيلندر بيفحصوا العربية قدامك.',
            en: 'Sylndr engineers inspect the car in front of you',
        },
        desc: {
            ar: 'إحنا بنفحص كل عربية علشان نضمن مطابقتها لمعايير سيلندر قبل العرض، ونتيجة الفحص بتكون مرتبطة بتاريخ المعاينة وممكن تعيد الفحص و تكون مع المهندس في نفس الوقت.',
            en: 'We inspect every car to make sure it meets Sylndr’s standards before listing. The inspection result is tied to the original inspection date, and you can request a reinspection and attend it with the engineer.',
        },

        stepsTitle: {
            ar: 'طلب إعادة فحص',
            en: 'Request Re-inspection',
        },
        steps: [
            {
                title: {
                    ar: 'الخطوة الأولى: احجز زيارة و حدد الموعد لمعاينة العربية.',
                    en: 'Step 1: Book a visit and choose the car inspection time.',
                },
            },
            {
                title: {
                    ar: 'الخطوة التانية: اكد الطلب لما خدمة العملاء يتواصلوا معك لتأكيد الحجز.',
                    en: 'Step 2: Confirm your request when customer support contacts you to finalize the booking.',
                },
            },
        ],
        info: {
            ar: 'مجرد اختيارك للخدمة مش معناها إنك هتدفع دلوقتي. الدفع هيتم بس لما تأكد زيارتك مع خدمة عملاء سيلندر.',
            en: 'Choosing the service doesn’t mean you’ll pay now. Payment only happens once your visit is confirmed with Sylndr’s customer support.',
        },
        cost: {
            ar: '1,500 ج.م',
            en: 'EGP 1,500',
        },
        icon: ReInspect,
        miniIcon: ReInspectMiniAr,
        videoURL: {
            DESKTOP: 'https://youtu.be/4iRzXGu6tFA?si=fE-W7EUhVlrMt0Lj',
            MOBILE: 'https://youtube.com/shorts/fS9ejehOKS0?si=80dPIsYI180cLlCl',
        },
    },
    {
        key: 'SafeTransaction',
        index: 1,
        title: {
            ar: 'شراء آمن مع سيلندر',
            en: 'Secure Purchase with Sylndr',
        },
        subTitle: {
            ar: 'سيلندر بتأمّن خطوات الشراء من الدفع لحد نقل الملكية وكل ده في 48 ساعة.',
            en: 'Sylndr secures the entire purchase process — from payment to ownership transfer — all within 48 hours.',
        },
        desc: {
            ar: 'لو عجبتك العربية بعد المعاينة، هتدفع من خلال سيلندر. هتاخد العربية في نفس الوقت، وإحنا هنخلص الورق مع الشريك في خلال ٤٨ ساعة.',
            en: 'If you like the car after the inspection, you’ll pay through Sylndr. You’ll get the car right away, and we’ll handle the paperwork with the partner within 48 hours.',
        },

        stepsTitle: {
            ar: 'طلب شراء آمن مع سيلندر',
            en: 'Buy Securely through Sylndr',
        },
        steps: [
            {
                title: {
                    ar: 'الخطوة الأولى: احجز زيارة و حدد الموعد لمعاينة العربية.',
                    en: 'Step 1: Book a visit and choose the car inspection time.',
                },
            },
            {
                title: {
                    ar: 'الخطوة التانية: اكد الطلب لما خدمة العملاء يتواصلوا معك لتأكيد الحجز.',
                    en: 'Step 2: Confirm your request when customer support contacts you to finalize the booking.',
                },
            },
        ],
        info: {
            ar: 'مجرد اختيارك للخدمة مش معناها إنك هتدفع دلوقتي. الدفع هيتم بس لما تأكد زيارتك مع خدمة عملاء سيلندر.',
            en: 'Choosing the service doesn’t mean you’ll pay now. Payment only happens once your visit is confirmed with Sylndr’s customer support.',
        },
        cost: {
            ar: '1,500 ج.م',
            en: 'EGP 1,500',
        },
        icon: BuyFromSylndr,
        miniIcon: BuyFromSylndrMiniAr,
        videoURL: {
            DESKTOP: 'https://youtu.be/4iRzXGu6tFA?si=fE-W7EUhVlrMt0Lj',
            MOBILE: 'https://youtube.com/shorts/fS9ejehOKS0?si=80dPIsYI180cLlCl',
        },
    },
];
